export type ShopSortItem = {
  value: string;
  label: string;
};

export const PRODUCTS_PER_PAGE = 16;
export const BLOGS_PER_PAGE = 6;

export const DEFAULT_SORT_VALUE = 'discounted'; 


export const SHOP_SORT_ITEMS: ShopSortItem[] = [
  {
		value: 'discounted',
		label: 'Discounted',
	},
  {
    value: "a-z",
    label: "Sort by name, A - Z",
  },
  {
    value: "z-a",
    label: "Sort by name, Z - A",
  },
  {
    value: "priceASC",
    label: "Sort by price, Low to High",
  },
  {
    value: "priceDESC",
    label: "Sort by price, High to Low",
  },
];
